<template>
  <Layout>
    <div class="order-detail-page">
      <!-- 面包屑导航 -->
      <div
        class="breadcrumb"
        style="background-color: transparent; margin-bottom: 20px"
      >
        <div class="breadcrumb-item">
          <span>{{ activityName }}</span>
        </div>
        <div class="breadcrumb-item-divider" style="padding: 0 4px">&gt;</div>
        <div class="breadcrumb-item">
          <span>订单管理</span>
        </div>
        <div class="breadcrumb-item-divider" style="padding: 0 4px">&gt;</div>
        <div class="breadcrumb-item" style="color: #1877ff; font-weight: bold">
          <span>{{ orderDetail.userName || "姓名昵称" }}</span>
        </div>
      </div>

      <!-- 订单卡片 -->
      <div class="order-card">
        <!-- 用户信息行 -->
        <div class="user-info">
          <img
            :src="orderDetail.userAvatar || defaultAvatar"
            alt="avatar"
            class="avatar"
          />
          <div class="user-detail">
            <div class="user-name-row">
              <div class="name-status-wrap">
                <span class="nickname">{{ orderDetail.userName }}</span>
                <span
                  :class="[
                    'status-tag',
                    getStatusClass(orderDetail.orderStatus),
                  ]"
                >
                  {{ getStatusText(orderDetail.orderStatus) }}
                </span>
              </div>
              <span class="order-no">#{{ orderDetail.serialNumber }}</span>
            </div>
            <div class="user-meta-row">
              <span class="user-id">ID: {{ orderDetail.userKey }}</span>
              <span class="join-time"
                >参与时间：{{ orderDetail.participateTime }}</span
              >
            </div>
          </div>
        </div>

        <!-- 费用明细 -->
        <div class="fee-section">
          <div class="fee-item">
            <div
              class="fee-row-top refund-reason"
              v-if="orderDetail.refundReason"
            >
              <span>申请退款原因：</span>
              <span>{{ orderDetail.refundReason }}</span>
            </div>
            <!-- 合计金额 -->
          </div>
          <!-- 报名费项 -->
          <div class="fee-item">
            <div class="fee-row-top">
              <span class="fee-name">{{ orderDetail.goodName }}</span>
              <span class="fee-quantity">x{{ orderDetail.goodNum }}</span>
            </div>
            <!-- 合计金额 -->
            <div class="total-section">
              <div class="total-row">
                <span class="total-label">合计金额：</span>
                <span class="total-value">{{ orderDetail.totalAmount }}元</span>
              </div>
              <!-- <div class="total-row">
              <span class="total-label">实付金额：</span>
              <span class="total-value paid"
                >{{ orderDetail.actualPayAmount }}元</span
              >
            </div> -->
              <!-- <div class="fee-row-bottom">
              <span class="fee-label">金额：</span>
              <span class="fee-price">{{ orderDetail.totalAmount }}元</span>
            </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 参与信息 -->
      <div class="participant-info-section">
        <div class="section-header">
          <span class="section-title">参与信息</span>
        </div>

        <!-- 动态显示参与信息字段 -->
        <!-- <ParticipationInfoCard
          v-for="(item, index) in registraList"
          :key="index"
          :item="item"
          :activityId="activityId"
          @delete-success="handleDeleteSuccess"
        /> -->
        <ActivityPlayerItem
          v-for="(item, index) in registraList"
          :key="item.id != null ? item.id : index"
          :item="item"
          showContent
        ></ActivityPlayerItem>
        <!-- <RegistrationListItem
          v-for="item in registraList"
          :key="item.id"
          :item="item"
          :activityId="activityId"
        >
        </RegistrationListItem> -->

        <!-- 订单信息 -->
        <div class="row-wrapper" style="padding: 20px 0 0 0">
          <div class="info-row">
            <span class="info-label">订单编号：</span>
            <span class="info-value">{{ orderDetail.orderNo || "-" }}</span>
          </div>

          <div class="info-row">
            <span class="info-label">下单时间：</span>
            <span class="info-value">{{
              formatTime(orderDetail.createTime)
            }}</span>
          </div>
          <div class="info-row" v-if="orderDetail.completeTime">
            <span class="info-label">完成时间：</span>
            <span class="info-value">{{
              orderDetail.completeTime || "-"
            }}</span>
          </div>
          <div
            class="info-row"
            v-if="orderDetail.cancelTime && orderDetail.totalPayAmount === 0"
          >
            <span class="info-label">取消时间：</span>
            <span class="info-value">{{ orderDetail.cancelTime || "-" }}</span>
          </div>
          <div class="info-row" v-if="orderDetail.refundApplyTime">
            <span class="info-label">退款申请时间：</span>
            <span class="info-value">{{
              orderDetail.refundApplyTime || "-"
            }}</span>
          </div>
          <div class="info-row" v-if="orderDetail.refundAgreeTime">
            <span class="info-label">退款同意时间：</span>
            <span class="info-value">{{
              orderDetail.refundAgreeTime || "-"
            }}</span>
          </div>
        </div>
      </div>
      <div class="btm-btn" v-if="orderDetail.orderStatus === 4">
        <div class="operation-btn" @click="handleAgreeRefund(orderDetail.id)">
          同意退款
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import copyrightConfig from "@/utils/config/changeCopyright.js";
import { getOrderDetail, orderAuditRefund } from "@/utils/api/wallet.js";
// import ParticipationInfoCard from "./ParticipationInfoCard/index.vue";
import ActivityPlayerItem from "@/components/ActivityPlayerItem/index.vue";

// import RegistrationListItem from "@/components/RegistrationListItem.vue";

const DEFAULT_AVATAR =
  "https://ossfastmake.mustke.com/12jielong/bdJL/default-avatar.png";

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
    title: "订单详情",
  },
  name: "OrderManagementDetail",
  components: { Layout, ActivityPlayerItem },
  data() {
    return {
      loading: false,
      // 默认头像
      defaultAvatar: DEFAULT_AVATAR,
      // 活动 ID
      activityId: "",
      activityName: "",
      // 订单详情
      orderDetail: {
        id: "",
        userName: "",
        userAvatar: "",
        userKey: "",
        serialNumber: "",
        // orderStatus: 1-待支付，2-未完成，3-已完成，4-待退款，5-已取消，6-退款失败，7-支付失败
        orderStatus: 1,
        goodName: "",
        goodNum: 1,
        totalAmount: 0,
        actualPayAmount: 0,
        participateTime: "",
        createTime: "",
        orderNo: "",
        useStatus: 0,
      },
      // 参与信息列表
      registraList: [],
    };
  },
  mounted() {
    this.setPageTitle();
    this.initData();
  },
  methods: {
    async handleAgreeRefund(orderId) {
      this.$confirm(
        "请确认是否同意该订单的退款申请？退款后，报名费将原路退回至参与者支付账户。",
        "退款操作确认",
        {
          confirmButtonText: "同意退款",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(async () => {
          // 调用同意退款接口
          const res = await orderAuditRefund({
            orderIds: [orderId],
            aggree: true,
          });
          if (res.status === 1) {
            // // 请求成功，前端乐观更新：将该订单标记为已同意
            // this.agreedOrderIds.push(orderId);
            this.$message.success("操作成功");
          } else {
            this.$message.error(res.msg || "操作失败");
          }
        })
        .catch(() => {
          this.$message.info("已拒绝退款");
        });
    },
    handleDeleteSuccess() {
      console.log("handleDeleteSuccess");
    },
    // 设置页面标题
    setPageTitle() {
      let suffix = "接龙加加";
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = "报名管家";
      }
      document.title = `订单详情 - ${suffix}`;
      console.log(document.title, "document.title");
    },

    // 初始化数据
    initData() {
      const query = this.$route.query;
      this.activityId = query.id || query.activityId || "";
      //   this.activityName = query.activityName || "";
      const orderId = query.id || query.orderId;

      if (orderId) {
        this.loadOrderDetail(orderId);
      }
    },

    // 加载订单详情
    async loadOrderDetail(orderId) {
      this.loading = true;
      try {
        const res = await getOrderDetail(orderId);
        console.log("[OrderManagementDetail] loadOrderDetail response:", res);
        if (res.status === 1 && res.data) {
          // 合并 order 和 orderSignInfo 数据
          this.orderDetail = {
            ...res.data.order,
            userName: res.data.orderSignInfo?.name || "",
            userAvatar: res.data.orderSignInfo?.profilePhoto || "",
          };
          this.activityName = res.data.order.activityName || "";
          // 解析参与信息列表
          this.registraList = this.parseOrderSignInfo(res.data.orderSignInfo);
          console.log(this.registraList, "this.registraList");
        }
      } catch (error) {
        console.error("获取订单详情失败:", error);
      } finally {
        this.loading = false;
      }
    },
    /**
     * 解析订单签到信息，构建参与者列表
     * @param {Object} orderSignInfo 订单签到信息对象
     * @returns {Array} registraList 参与者列表
     */
    parseOrderSignInfo(orderSignInfo) {
      if (!orderSignInfo) return [];

      let signInfo = [];
      try {
        signInfo =
          typeof orderSignInfo.signInfo === "string"
            ? JSON.parse(orderSignInfo.signInfo)
            : orderSignInfo.signInfo || [];
      } catch (e) {
        signInfo = [];
      }

      return [
        {
          id: orderSignInfo.id,
          name: orderSignInfo.name || "",
          nickname: orderSignInfo.nickname || "",
          profile_photo: orderSignInfo.profilePhoto || "",
          add_time: orderSignInfo.addTime || "",
          sign_info: signInfo,
          sign_index: orderSignInfo.signIndex || "",
        },
      ];
    },

    // 获取状态样式类
    getStatusClass(status) {
      const statusMap = {
        1: "status-pending-pay", // 待支付
        2: "status-pending-complete", // 未完成
        3: "status-completed", // 已完成
        4: "status-pending-refund", // 待退款
        5: "status-canceled", // 已取消
        6: "status-refund-failed", // 退款失败
        7: "status-pay-failed", // 支付失败
      };
      return statusMap[status] || "";
    },

    // 获取状态文本
    getStatusText(status) {
      const textMap = {
        1: "待支付",
        2: "未完成",
        3: "已完成",
        4: "待退款",
        5: "已取消",
        6: "退款失败",
        7: "支付失败",
      };
      return textMap[status] || "";
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return "";
      const date = new Date(time);
      if (isNaN(date.getTime())) return time;
      return date.toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-detail-page {
  padding: 0;
}

// 面包屑导航
.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;

  .breadcrumb-item {
    cursor: pointer;

    &:hover {
      color: #1877ff;
    }
  }

  .breadcrumb-item-divider {
    color: #909399;
  }
}

// 订单卡片
.order-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;

  .user-info {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;

    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 12px;
      object-fit: cover;
    }

    .user-detail {
      flex: 1;

      .user-name-row {
        display: flex;
        align-items: flex-start;
        margin-bottom: 6px;

        .name-status-wrap {
          flex: 1;
          display: flex;
          align-items: center;
          gap: 8px;

          .nickname {
            font-size: 16px;
            font-weight: bold;
            color: #303133;
          }

          .status-tag {
            padding: 2px 8px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;

            &.status-pending-pay {
              background: #fff7e6;
              color: #ff9500;
            }

            &.status-pending-complete {
              background: #e6f7ff;
              color: #1890ff;
            }

            &.status-completed {
              background: #e8f5e9;
              color: #67c23a;
            }

            &.status-pending-refund {
              background: #ffebee;
              color: #f56c6c;
            }

            &.status-canceled {
              background: #f5f5f5;
              color: #909399;
            }

            &.status-refund-failed {
              background: #ffebee;
              color: #f56c6c;
            }

            &.status-pay-failed {
              background: #fff7e6;
              color: #ff9500;
            }
          }
        }

        .order-no {
          font-size: 14px;
          color: #303133;
          font-weight: bold;
        }
      }

      .user-meta-row {
        font-size: 13px;
        color: #909399;

        .user-id {
          margin-right: 16px;
        }
      }
    }
  }

  .fee-section {
    display: flex;
    flex-direction: column;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;

    .fee-item {
      margin-bottom: 6px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .fee-row-top {
        font-size: 16px;
        color: #323b5a;
        .fee-name {
        }

        .fee-quantity {
          margin-left: 10px;
        }
        &.refund-reason {
          color: #1877ff;
        }
      }

      .fee-row-bottom {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 16px;

        .fee-label {
          color: #606266;
          margin-right: 8px;
        }

        .fee-price {
          font-weight: bold;
          color: #f56c6c;
        }
      }
    }

    .total-section {
      .total-row {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 8px;

        .total-label {
          font-size: 14px;
          color: #606266;
          margin-right: 8px;
        }

        .total-value {
          font-size: 16px;
          font-weight: bold;
          color: #f56c6c;

          &.paid {
            color: #f56c6c;
          }
        }
      }
    }
  }
}

// 参与信息区域
.participant-info-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  margin-bottom: 20px;

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .section-title {
      font-size: 16px;
      font-weight: bold;
      color: #323b5a;
    }

    .unused-tag {
      background: linear-gradient(135deg, #ff9a00 0%, #ffb600 100%);
      color: #fff;
      font-size: 12px;
      padding: 4px 16px;
      border-radius: 4px;
      position: absolute;
      right: 10px;
      top: 10px;
      transform: rotate(45deg);
      transform-origin: center;
    }
  }

  .info-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
    font-size: 14px;

    .info-label {
      color: #909399;
      min-width: 70px;
    }

    .info-value {
      color: #303133;
      flex: 1;
    }
  }

  .info-list {
    .info-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 12px;
      font-size: 14px;

      .info-label {
        color: #909399;
        min-width: 70px;
      }

      .info-value {
        color: #303133;
        flex: 1;
      }
    }
  }

  .info-divider {
    height: 1px;
    background-color: #ebeef5;
    margin: 12px 0;
  }
}
.btm-btn {
  position: fixed;
  left: 0;
  bottom: 80px;
  right: 0;
  .operation-btn {
    cursor: pointer;
    margin: 0 auto;
    width: 436px;
    height: 66px;
    line-height: 66px;
    background: #1877ff;
    border-radius: 33px;
    font-size: 21px;
    font-weight: Bold;
    text-align: center;
    color: #ffffff;
  }
}
</style>
